import React, { useCallback, useEffect, useState } from 'react'
import message from 'antd/lib/message'

import { CloseIcon, PrimaryButton } from 'components'
import Modal from 'components/AuthModal/components/Modal'
import Overlay from 'components/AuthModal/components/Overlay'
import ProfileLabel from 'components/Profile/ProfileLabel'
import ProfileTextarea from 'components/Profile/ProfileTextarea'

import { OVERLAY } from 'components/AuthModal/styles'

const IdealProfileTemplateModal = ({ show, idealProfilePromptTemplate, onClose, onSubmit }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [input, setInput] = useState(idealProfilePromptTemplate)

  const handleInputChange = useCallback(e => {
    const { name, value } = e.target

    setInput(prev => ({
      ...prev,
      [name]: value,
    }))
  }, [])

  useEffect(
    () => {
      setInput(idealProfilePromptTemplate)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [show]
  )

  const handleSubmit = useCallback(
    async e => {
      e.preventDefault()

      message.loading('submitting...', 0)
      setIsSubmitting(true)

      const showError = errorMessage => {
        message.destroy()
        message.error(errorMessage || 'Please try again')
      }

      try {
        await onSubmit(input)

        message.destroy()
        message.success('New template applied successfully', 2.5)
        onClose()
      } catch (error) {
        showError(error.message)
      } finally {
        setIsSubmitting(false)
      }
    },
    [input, onClose, onSubmit]
  )

  return (
    <Overlay show={show} className={OVERLAY} preventEscBackdropClose={true} onClose={onClose}>
      <Modal innerClassName="bg-white rounded-t-3xl overflow-y-scroll md:rounded-xl">
        <div className="relative w-full p-5 md:p-7 md:py-5 md:w-108">
          <button className="bg-transparent absolute top-3 right-4" onClick={onClose}>
            <CloseIcon className="w-3 h-3" />
          </button>
          <div className="text-center text-xl font-bold font-ownersWide mb-10 underline">
            Update Ideal Prompt Modal
          </div>
          <form onSubmit={handleSubmit}>
            <div className="text-left">
              <div className="mb-6">
                <ProfileLabel className="text-black font-semibold">System</ProfileLabel>
                <ProfileTextarea
                  name="system"
                  required={true}
                  value={input.system || ''}
                  onChange={handleInputChange}
                  classNames={{ input: 'md:text-left' }}
                />
              </div>
              <div className="mb-6">
                <ProfileLabel className="text-black font-semibold">User</ProfileLabel>
                <ProfileTextarea
                  name="user"
                  required={true}
                  value={input.user || ''}
                  onChange={handleInputChange}
                  classNames={{ input: 'md:text-left' }}
                />
              </div>
              <div>
                <ProfileLabel className="text-black font-semibold">Assistant</ProfileLabel>
                <ProfileTextarea
                  name="assistant"
                  required={true}
                  value={input.assistant || ''}
                  onChange={handleInputChange}
                  classNames={{ input: 'md:text-left' }}
                />
              </div>
            </div>
            <div className="flex justify-center mt-14">
              <PrimaryButton
                disabled={!input.system || !input.user || !input.assistant}
                type="submit"
                loading={isSubmitting}
                className="text-base h-10"
              >
                Submit
              </PrimaryButton>
            </div>
          </form>
        </div>
      </Modal>
    </Overlay>
  )
}

export default IdealProfileTemplateModal
